import {createReducer} from '@reduxjs/toolkit';

import {initialState} from './state';
import {
    clearAction,
    setButtonsAction,
    setColorAction,
    setHeaderAction,
    setIsOpenAction,
    setMessageAction,
    showAction,
} from './actions';

export const reducer = createReducer(initialState, builder =>
    builder
        .addCase(showAction.pending, (state, action) => {
            return {...state};
        })
        .addCase(showAction.fulfilled, (state, action) => {
            const {header, message, color, buttons, duration} = action.payload;
            return {
                ...state,
                isOpen: true,
                header,
                message: message || '',
                color: color || 'primary',
                buttons,
                // Persist the per-toast lifetime so AppToast can honour it (e.g. a
                // 5000ms reminder). Default to 3000ms — the value AppToast used to
                // hardcode — so ordinary toasts keep their 3s lifetime.
                duration: duration ?? 3000,
                generation: state.generation + 1,
            };
        })
        .addCase(showAction.rejected, (state, action) => {
            return {...state, isOpen: false};
        })

        .addCase(setIsOpenAction.pending, (state, action) => {
            return {...state};
        })
        .addCase(setIsOpenAction.fulfilled, (state, action) => {
            const {isOpen} = action.payload;
            return {...state, isOpen: !!isOpen};
        })
        .addCase(setIsOpenAction.rejected, (state, action) => {
            return {...state, isOpen: false};
        })

        .addCase(setButtonsAction.pending, (state, action) => {
            return {...state};
        })
        .addCase(setButtonsAction.fulfilled, (state, action) => {
            const {buttons} = action.payload;
            return {...state, buttons};
        })
        .addCase(setButtonsAction.rejected, (state, action) => {
            return {...state};
        })

        .addCase(setColorAction.pending, (state, action) => {
            return {...state};
        })
        .addCase(setColorAction.fulfilled, (state, action) => {
            const {color} = action.payload;
            return {...state, color};
        })
        .addCase(setColorAction.rejected, (state, action) => {
            return {...state};
        })

        .addCase(setHeaderAction.pending, (state, action) => {
            return {...state};
        })
        .addCase(setHeaderAction.fulfilled, (state, action) => {
            const {header} = action.payload;
            return {...state, header};
        })
        .addCase(setHeaderAction.rejected, (state, action) => {
            return {...state};
        })

        .addCase(setMessageAction.pending, (state, action) => {
            return {...state};
        })
        .addCase(setMessageAction.fulfilled, (state, action) => {
            const {message} = action.payload;
            return {...state, message: message || ''};
        })
        .addCase(setMessageAction.rejected, (state, action) => {
            return {...state};
        })

        .addCase(clearAction.pending, (state, action) => {
            return {...state};
        })
        .addCase(clearAction.fulfilled, (state, action) => {
            const {generation} = action.payload || {};
            // A dismiss carries the generation of the toast it belongs to. If a
            // second toast has been shown since, that dismiss is stale — ignoring
            // it stops the first toast's timer from swallowing the second.
            // A generation-less clear (e.g. the mount reset) always applies.
            if (generation !== undefined && generation !== state.generation) {
                return state;
            }
            // Atomic full reset: close AND clear every field in one update so a
            // renderable `{ isOpen: true, message: '' }` state is never reachable.
            // The generation is monotonic — it never rewinds on clear.
            return {...state, isOpen: false, header: '', message: '', color: 'primary', buttons: undefined};
        })
        .addCase(clearAction.rejected, (state, action) => {
            return {...state};
        })


);
